<template>
  <ItemRow>
    <ItemWithLabel
      :column="columns[0]"
    >
      <Link
        :text="itemData.name"
        :to="getSharedFolderPath(itemData.uuid)"
      />
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[1]"
    >
      {{ itemData.usersWithAccess }}
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[2]"
    >
      {{ formattedDateCreated }}
    </ItemWithLabel>
    <ItemWithLabel
      class="visibleOverflow"
      :column="columns[3]"
    >
      <PasswordManagerPasswordScoreStatus
        class="passwordManagerPasswordScoreStatus"
        :hasPasswords="!!itemData.passwordsCount"
        :passwordScore="itemData.passwordsScore"
        :scoreUpdatedAt="itemData.scoreUpdatedAt"
      />
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';
import DateUtil from 'client/util/DateUtil';
import PasswordManagerPasswordScoreStatus from 'client/PasswordManager/components/PasswordManagerPasswordScoreStatus.vue';

export default {
  name: 'SharedFoldersItemListRow',

  components: {
    ItemRow,
    ItemWithLabel,
    Link,
    PasswordManagerPasswordScoreStatus,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    formattedDateCreated() {
      return DateUtil.customFormatDate(this.itemData.createdAt, 'MMM DD, YYYY');
    },
  },

  methods: {
    getSharedFolderPath(id) {
      return `/passwordmanager/sharedfolders/${id}/details`;
    },
  },
};
</script>

<style scoped>
.passwordManagerPasswordScoreStatus {
  margin-right: var(--jc-spacer-small);
}

.visibleOverflow {
  overflow: visible;
}
</style>
